import { env } from ".env";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import Transactions from "services/apis/transactionsAPI";
import { logger } from "utils/logger/logger";
import { CustomButton } from "components/component-styles/buttons/index.styled";
import { TransactionModalContainer } from "./transactionModal.styled";

export default function TransactionModal({ closing }) {
  const [download, setDownload] = useState(false);
  const [downloadUrlState, setDownloadUrlState] = useState("");
  const [validInputs, setValidInputs] = useState(false);
  const switchModeState = useRef(false);
  const switchAggregateState = useRef(false);
  const inputsContainer = useRef(null);

  const [startTimesState, setStartTimesState] = useState({
    day: null,
    month: null,
    year: "1401",
  });

  const [endTimesState, setEndTimesState] = useState({
    day: null,
    month: null,
    year: "1402",
  });

  function handleInputsTime(e) {
    const id = Number(e.target.id);
    const rawValue = e.target.value;
    const value = Number(e.target.value);

    function handleInputs() {
      function returnValidation(type, validation) {
        return {
          type,
          value,
          isValid: validation,
        };
      }

      function addError() {
        document.getElementById(`${id}`).classList.add("error");
      }

      function removeError() {
        document.getElementById(`${id}`).classList.remove("error");
      }

      function nextInputFocus() {
        if (id <= 6) {
          document.getElementById(`${id + 1}`).focus();
        }
      }

      if (id === 1 || id === 2 || id === 4 || id === 5) {
        if (id === 1 || id === 4) {
          if (value <= 31 && value >= 1 && rawValue.length === 2) {
            removeError();
            nextInputFocus();
            return returnValidation("day", true);
          } else {
            addError();
            return returnValidation("day", false);
          }
        } else {
          if (value <= 12 && value >= 1 && rawValue.length === 2) {
            removeError();
            nextInputFocus();
            return returnValidation("month", true);
          } else {
            addError();
            return returnValidation("month", false);
          }
        }
      } else {
        if (value < 1360 || (value > 1450 && rawValue.length !== 4)) {
          addError();
          return returnValidation("year", false);
        } else {
          removeError();
          if (id === 3) {
            nextInputFocus();
          }

          return returnValidation("year", true);
        }
      }
    }
    if (typeof value !== "undefined") {
      const checkValidation = handleInputs();
      const checkType = checkValidation.type;

      if (checkValidation.isValid) {
        if (id < 4) {
          setStartTimesState({ ...startTimesState, [checkType]: rawValue });
        } else {
          setEndTimesState({ ...endTimesState, [checkType]: rawValue });
        }
      }
    }
  }

  useEffect(() => {
    if (
      startTimesState.day &&
      startTimesState.month &&
      startTimesState.year &&
      endTimesState.day &&
      endTimesState.month &&
      endTimesState.year
    ) {
      setValidInputs(true);
    } else {
      setValidInputs(false);
    }
  }, [startTimesState, endTimesState]);

  async function handleRequest() {
    if (validInputs) {
      if (Number(endTimesState.year) < Number(startTimesState.year)) {
        toast.warning("سال پایانی نمیتواند از سال ابتدایی کمتر باشد");
      } else {
        setValidInputs(true);
        let aggregate = "transactionAllUser";
        let type = "deposited";

        if (switchModeState.current.checked) {
          type = "withdrawal";
        }

        if(switchAggregateState.current.checked){
          aggregate = "transactionPerUser"
        }

        const startDate = `${startTimesState.year}-${startTimesState.month}-${startTimesState.day}`;
        const endDate = `${endTimesState.year}-${endTimesState.month}-${endTimesState.day}`;
        const reqParams = {
          startDate,
          endDate,
          type,
          aggregate
        };

        const response = await new Transactions().getDepositedReport(reqParams)

        if (response.type) {
          logger.log()("/download/res.data.data !!!", response);

          const downloadUrl = `${env.REACT_APP_BASE_URL}download/${response.data.data}`;

          setDownloadUrlState(downloadUrl);

          setDownload(true);

          toast.success("فایل اکسل آماده ی دانلود است.");
        } else {
          toast.warning("اطلاعاتی در بازه ی زمانی مشخص شده وجود ندارد.");
        }
      }
    } else {
      toast.warning("لطفا تمامی فیلد ها را پر کنید.");
    }
  }

  function downloadFile() {
    setValidInputs(false);

    setStartTimesState({
      day: null,
      month: null,
      year: "1401",
    });

    setEndTimesState({
      day: null,
      month: null,
      year: "1402",
    });

    Array.from(inputsContainer.current.querySelectorAll("input"), (item) => {
      if (
        item.id === "1" ||
        item.id === "2" ||
        item.id === "4" ||
        item.id === "5"
      ) {
        item.value = "";
      }
    });

    setDownload(false);
  }

  return (
    <TransactionModalContainer>
      <div className="messageBox">
        <div className="title">دریافت گزارش مالی</div>
        <div className="content">
          <p>
            تاریخ ابتدایی و انتهایی برای دریافت بازه ی گزارش مالی را وارد کنید.
          </p>
          <div className="switchMode">
            <span>گزارش برداشت</span>
            <label className="switch">
              <input type="checkbox" ref={switchModeState} />
              <span className="slider round"></span>
            </label>
            <span>گزارش واریز</span>
          </div>
          <div className="switchMode">
            <span>گزارش تجمیعی به ازای هر کاربر</span>
            <label className="switch">
              <input id='report-user-wallet' type="checkbox" ref={switchAggregateState} />
              <span className="slider round"></span>
            </label>
            <span>گزارش همه ی کاربران</span>
          </div>
          <div
            className="timePeriod"
            onChange={handleInputsTime}
            ref={inputsContainer}
          >
            <div className="timeBox">
              <span>
                تاریخ شروع : <span>روز / ماه / سال</span>
              </span>
              <div className="inputs">
                <input id="1" type="number" placeholder="01" />
                <input id="2" type="number" placeholder="02" />
                <input
                  id="3"
                  type="number"
                  placeholder="1401"
                  defaultValue="1401"
                />
              </div>
            </div>
            <div className="timeBox">
              <span>
                تاریخ پایان : <span>روز / ماه / سال</span>
              </span>
              <div className="inputs">
                <input id="4" type="number" placeholder="03" />
                <input id="5" type="number" placeholder="10" />
                <input
                  id="6"
                  type="number"
                  placeholder="1402"
                  defaultValue="1402"
                />
              </div>
            </div>
          </div>
        </div>
        <div className={`displayResult ${validInputs && "valid"}`}>
          <div>
            <span>{endTimesState.year}/</span>
            <span>{endTimesState.month ?? "--"}/</span>
            <span>{endTimesState.day ?? "--"}</span>
          </div>
          <div>تا</div>
          <div>
            <span>{startTimesState.year}/</span>
            <span>{startTimesState.month ?? "--"}/</span>
            <span>{startTimesState.day ?? "--"}</span>
          </div>
        </div>
        <div className="sendRequest">
          <CustomButton onClick={handleRequest}>ارسال درخواست</CustomButton>
        </div>
        <div className="btns">
          <a
            className={!download && "disabled"}
            href={downloadUrlState}
            download
            onClick={downloadFile}
          >
            دانلود
          </a>
          <CustomButton onClick={closing}>بستن</CustomButton>
        </div>
      </div>
    </TransactionModalContainer>
  );
}
